import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";

type Props = {};

function LogoutPage({}: Props) {
    const { logout } = useAuth();

    useEffect(() => {
        logout();
    }, []);
    return <div className="m-8">Logging out...</div>;
}

export default LogoutPage;
